import { supabase } from "@/lib/supabase";

export interface ShopVisibility {
    shop_id: number;
    updated_at: string | null;
    end_date: string;
    priority_weight: number | null;
}

export const getBoostedShops = async (shopId: number): Promise<ShopVisibility | null> => {
    const { data, error } = await supabase
        .from("ShopVisibility")
        .select("*")
        .eq("shop_id", shopId)
        .maybeSingle();

    if (error) {
        console.error("Error fetching shop visibility:", error);
        throw error;
    }

    return data;
};
